<template>
  <div>
    <v-card>
      <v-tabs
        v-model="tab"
        color--text="red"
        grow
      >
        <v-tabs-slider color="#e72b37" />
        <v-tab
          v-for="section in adminSectionItems"
          :key="section.key"
          style="color: #e72b37"
        >
          {{ section.title }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        id="custom-tab-items"
        v-model="tab"
      >
        <v-tab-item
          v-for="(section, index) in adminSectionItems"
          :key="section.key"
        >
          <resource-calendar-dashboard-tab
            v-if="tab === index && section.key === 'dashboard'"
          />
          <resource-calendar-holidays-tab
            v-if="tab === index && section.key === 'holidays'"
            :refresh-token="holidaysRefreshToken"
          />
          <resource-calendar-regions-tab
            v-if="tab === index && section.key === 'regions'"
          />

          <resource-calendar-import-export-tab
            v-if="tab === index && section.key === 'importExport'"
            @resource-calendar-imported="handleResourceCalendarImported"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import ResourceCalendarImportExportTab from "@/components/resourceCalendar/tabs/ResourceCalendarImportExportTab.vue";
import ResourceCalendarDashboardTab from "@/components/resourceCalendar/tabs/ResourceCalendarDashboardTab.vue";
import ResourceCalendarHolidaysTab from "@/components/resourceCalendar/tabs/ResourceCalendarHolidaysTab.vue";
import ResourceCalendarRegionsTab from "@/components/resourceCalendar/tabs/ResourceCalendarRegionsTab.vue";

export default {
  components: {
    ResourceCalendarImportExportTab,
    ResourceCalendarDashboardTab,
    ResourceCalendarHolidaysTab,
    ResourceCalendarRegionsTab,
  },
  data() {
    return {
      tab: 0,
      holidaysRefreshToken: 0,
    };
  },
  computed: {
    adminSectionItems() {
      const items = [];


      items.push(
        {
          key: "dashboard",
          title: "Dashboard",
        },
        {
          key: "holidays",
          title: "Feiertage",
        },
        {
          key: "regions",
          title: "Feiertagsregionen verwalten",
        },
      );
      if (this.$IsUserInRole("AllgemeinerFeiertagskalenderAdministration")) {
        items.push({
          key: "importExport",
          title: "Export-/Import der Feiertage",
        });
      }

      return items;
    },
  },
  methods: {
    handleResourceCalendarImported() {
      this.holidaysRefreshToken += 1;
    },
  },
};
</script>
<style scoped>
</style>
